import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AlertController,
  ToastController,
  LoadingController,
} from '@ionic/angular';

@Injectable()
export class ErrorHandlerService {
  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
  ) {}

  formValidationError() {
    return this.translate
      .get('Errors.Validation.Message')
      .subscribe((message) => this.showToast(message));
  }

  async showToast(message) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 5000,
      position: 'top',
      // showCloseButton: true,
      // closeButtonText: 'Done'
    });
    toast.present();
  }

  async showAlert(message) {
    const alert = await this.alertCtrl.create({
      header: message.title,
      message: message.text,
      buttons: [
        {
          text: 'OK',
        },
      ],
    });
    await alert.present();
  }

  handle(error: any) {
    console.warn(error);
    if (error instanceof HttpErrorResponse) {
      console.log(
        'ERROR IN HANDLER FUNCTION (error-handler.service.ts) => ',
        error,
      );
      switch (error.status) {
        case -1:
        case 0:
          this.translate
            .get('Errors.Network')
            .subscribe((message) => this.showToast(message));
          return;
        case 401:
          this.translate.get('Errors.Authentication').subscribe((message) => {
            if (typeof error.error === 'object' && error.error.error) {
              this.showToast(error.error.error);
            } else {
              this.showToast(message);
            }
          });
          return;
        case 403:
          this.translate
            .get('Errors.Forbidden')
            .subscribe((message) => this.showToast(message));
          return;
        case 404:
          this.translate
            .get('Errors.NotFound')
            .subscribe((message) => this.showToast(message));
          return;
        case 422:
          this.translate
            .get([
              'Errors.Validation.Title',
              'Errors.Validation.Message',
              'Buttons.Ok',
            ])
            .subscribe((messages) => {
              let message = messages['Errors.Validation.Message'];
              if (typeof error.error === 'object' && error.error.errors) {
                const keys = Object.keys(error.error.errors);

                if (keys.length) {
                  const errorMessage = Array.isArray(
                    error.error.errors[keys[0]],
                  )
                    ? error.error.errors[keys[0]][0]
                    : error.error.errors[keys[0]];

                  message = `<em style='white-space: pre-line'>${errorMessage}</em>`;
                }
              }

              return this.showAlert({
                text: message,
              });
            });
          return;
        case 429:
          this.translate
            .get('Errors.Throttle')
            .subscribe((message) => this.showToast(message));
          return;
      }

      if (typeof error.error === 'object' && error.error.error) {
        this.showToast(error.error.error);
        return;
      } else {
        this.showToast(error.error);
      }

      this.translate
        .get('Errors.Server')
        .subscribe((message) => this.showToast(message));
      return;
    }

    this.translate
      .get('Errors.Generic')
      .subscribe((message) => this.showToast(message));
  }

  handleIapError(error: CdvPurchase.IError) {
    if (error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
      this.showToast(this.translate.instant('IAP.PurchaseCancelled'));

      return;
    }

    this.showToast(this.translate.instant('IAP.Error', error));

    // TODO handle purchase error
  }
}
